import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { IHotCellAngularRenderedCellComponent } from "~app/common/components/hot-doc/hotdoc/hot-cell-angular-renderer.service";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { KundorderradCommentComponent } from "~app/features/forsaljning/kundorder/kundorder-details/kundorderrad-comment/kundorderrad-comment.component";
import { KundorderradAggregat } from "../../models/jlp-kundorder.model";

@Component({
    selector: "rask-kundorderrad-cell",
    templateUrl: "./kundorderrad-cell.component.html",
    styleUrls: ["./kundorderrad-cell.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterLink,
        NgbTooltip,
        IconButtonComponent
    ]
})
export class KundorderradCellComponent implements IHotCellAngularRenderedCellComponent {
    sourceAggregat: KundorderradAggregat;

    private readonly raskModalService = inject(RaskModalService);

    applyData = (source: KundorderradAggregat) => {
        this.sourceAggregat = source;
    };

    getFullKundNamn(): string {
        return this.sourceAggregat.kundNamn.replace(/(\r\n|\n|\r)/gm, "");
    }

    getShortKundNamn(): string {
        return this.sourceAggregat.kundNamn.substring(0, 20).replace(/(\r\n|\n|\r)/gm, "");
    }

    openComment(): void {
        this.raskModalService.open("Kommentar", KundorderradCommentComponent, "md", true, {
            kundorderradId: this.sourceAggregat.kundorderradId,
            editMode: false
        });
    }
}
